
<nz-card class="review-item-container" *ngIf="visible">
    <!--TODO implement helpfulaction -->
<!--    <div class="helpful-container">-->
<!--        <i nz-icon nzType="like" nzTheme="outline"></i>-->
<!--        <span class="helpful-button">Helpful</span>-->
<!--        <span>(0)</span>-->
<!--    </div>-->
    <nz-comment [nzAuthor]="reviewerName ? reviewerName : 'Anonimous'">
        <nz-avatar
                nz-comment-avatar
                nzIcon="user"
                [nzSrc]="avatar"
        ></nz-avatar>
        <nz-comment-content>
            <!--TODO fix backend for account details -->
<!--            <div *ngIf="isBuyer" class="user-type">Buyer</div>-->
<!--            <div *ngIf="isSeller" class="user-type">Seller</div>-->
<!--            <div *ngIf="isInstructor" class="user-type">Instructor</div>-->
            <div>
                <nz-rate [ngModel]="rating" nzDisabled></nz-rate><span>({{rating}}/5)</span>
            </div>
            <div [innerHTML]="reviewText"></div>
        </nz-comment-content>
    </nz-comment>
</nz-card>

